import { post } from '@/utils/request'

/**
 * 淘客的订单列表 
 * 
 * @param {Number} tk_status 淘客订单状态，3：订单结算，12：订单付款， 13：订单失效，14：订单成功
 * @param {String} owner_cms_member_id 归属代理/CMS会员ID
 * @param {String} trade_id 淘宝订单号
 * @param {String} inv_user_telephone 邀请者手机号
 * @param {String} create_time_begin 下单时间开始 YYYY-MM-DD HH:mm:ss
 * @param {String} create_time_end 下单时间结束 YYYY-MM-DD HH:mm:ss
 * @param {Number} [page=1] 页码
 * @param {Number} [pagesize=10] 分页大小
 */
export function taoke_order_list(data) {
  return post('taoke_order_list', data)
}

/**
 * 淘客的拼多多订单列表 
 * 
 * @param {Number} tk_status 淘客订单状态，3：订单结算，12：订单付款， 13：订单失效，14：订单成功
 * @param {String} owner_cms_member_id 归属代理/CMS会员ID
 * @param {String} trade_id 淘宝订单号
 * @param {String} inv_user_telephone 邀请者手机号
 * @param {String} create_time_begin 下单时间开始 YYYY-MM-DD HH:mm:ss
 * @param {String} create_time_end 下单时间结束 YYYY-MM-DD HH:mm:ss
 * @param {Number} [page=1] 页码
 * @param {Number} [pagesize=10] 分页大小
 */
export function taoke_ddk_order_list(data) {
  return post('taoke_ddk_order_list', data)
}

/**
 * 淘客的京东订单列表 
 * 
 * @param {Number} tk_status 淘客订单状态，3：订单结算，12：订单付款， 13：订单失效，14：订单成功
 * @param {String} owner_cms_member_id 归属代理/CMS会员ID
 * @param {String} trade_id 淘宝订单号
 * @param {String} inv_user_telephone 邀请者手机号
 * @param {String} create_time_begin 下单时间开始 YYYY-MM-DD HH:mm:ss
 * @param {String} create_time_end 下单时间结束 YYYY-MM-DD HH:mm:ss
 * @param {Number} [page=1] 页码
 * @param {Number} [pagesize=10] 分页大小
 */
export function taoke_jd_order_list(data) {
  return post('taoke_jd_order_list', data)
}

/**
 * 淘客的订单指派归属人 
 * 
 * @param {String} id 订单id
 * @param {String} telephone 邀请者手机号
 */
export function taoke_order_assign(data) {
  return post('taoke_order_assign', data)
}

/**
 * 淘客的拼多多订单指派归属人 
 * 
 * @param {String} id 订单id
 * @param {String} telephone 邀请者手机号
 */
export function taoke_ddk_order_assign(data) {
  return post('taoke_ddk_order_assign', data)
}

/**
 * 淘客的京东订单指派归属人 
 * 
 * @param {String} id 订单id
 * @param {String} telephone 邀请者手机号
 */
export function taoke_jd_order_assign(data) {
  return post('taoke_jd_order_assign', data)
}
/**
 * 淘客查看佣金提现申请记录 
 * 
 * @param {String} telephone 申请人手机号码
 * @param {String} add_time_begin 开始时间 YYYY-MM-DD HH:mm:ss
 * @param {String} add_time_end 结束时间 YYYY-MM-DD HH:mm:ss
 * @param {String} page 页码
 * @param {String} pagesize 分页大小
 */
export function taoke_commission_withdraw_apply_list(data) {
  return post('taoke_commission_withdraw_apply_list', data)
}

/**
 * 淘客审核佣金提现申请 
 * 
 * @param {String} id 申请id
 * @param {String} agree 1 通过 2 拒绝
 * @param {String} reject_reason 拒绝理由
 */
export function taoke_commission_withdraw_apply_confirm(data) {
  return post('taoke_commission_withdraw_apply_confirm', data)
}


/**
 * 淘客CMS会员提现条件设定 
 * 
 * @param {Number} withdraw_min_amount 最低提款金额
 * @param {Number} withdraw_base_amount 倍数（整数）
 */
export function taoke_cms_withdraw_set(data) {
  return post('taoke_cms_withdraw_set', data)
}


/**
 * 淘客CMS会员佣金修改 
 * @param {String} telephone 需要修改的会员手机号，请注意必须是自己cms的会员
 * @param {String} commission 佣金变化金额 整数为添加，负数为减少，单位是元
 * @param {String} reson 佣金变化理由
 */
export function taoke_cms_member_commission_modify(data) {
  return post('taoke_cms_member_commission_modify', data)
}

/**
 * 淘客CMS会员佣金修改记录 
 * @param {String} telephone 会员手机号，请注意必须是自己cms的会员
 * @param {String} begin_time 时间开始 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {String} end_time 时间结束 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {String} page 页码
 * @param {String} pagesize 分页大小
 */
export function taoke_cms_member_commission_modify_log(data) {
  return post('taoke_cms_member_commission_modify_log', data)
}

/**
 * 淘客的订单立即结算 
 * @param {id} id 订单id
 */
export function taoke_order_settle(data) {
  return post('taoke_order_settle', data)
}

/**
 * 淘客的拼多多订单立即结算 
 * @param {id} id 订单id
 */
export function taoke_ddk_order_settle(data) {
  return post('taoke_ddk_order_settle', data)
}

/**
 * 淘客的京东订单立即结算 
 * @param {id} id 订单id
 */
export function taoke_jd_order_settle(data) {
  return post('taoke_jd_order_settle', data)
}

/**
 * 淘客查看会员余额变化记录
 * @param {String} tsid tsid
 * @param {String} type 类型 1 收入 2支出 不输入 是全部
 * @param {Number} page 页码
 * @param {Number} pagesize 分页大小
 * @param {String} cms_member_id cms会员id
 */
export function taoke_cms_member_money_log(data) {
  return post('taoke_cms_member_money_log', data)
}






